<template>
  <div>
    <el-form :model="form" label-width="80px">
      <el-form-item label="标题">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="电话">
        <el-input v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item label="手机">
        <el-input v-model="form.cellphone"></el-input>
      </el-form-item>
      <el-form-item label="邮箱">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <el-form-item label="地址">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save">立即创建</el-button>
        <el-button @click="goback()">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: "",
        phone: "",
        cellphone: "",
        email: "",
        address: ""
      }
    };
  },
  methods: {
    save() {
      console.log("submit!");
    },
    goback(){
      this.$router.push('/admin/index/onepage')
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/onepage/relation.vue